var exports = {
  "D": "x31de4314--a76910--title",
};

module.exports = exports;
